'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialDribbble = function TiSocialDribbble(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z m11.6 13.8c-2.9-0.5-5.9-0.3-8.7 0.4-0.3-0.7-0.6-1.4-1-2.1 2.4-1.4 4.5-3.2 6.2-5.4 1.9 1.8 3.2 4.3 3.5 7.1z m-4.7-8.2c-1.6 2.1-3.5 3.8-5.7 5-1.3-2.4-2.9-4.6-4.7-6.7 1.1-0.4 2.3-0.6 3.5-0.6 2.6 0 5 0.9 6.9 2.3z m-12-1.1c1.9 2.1 3.5 4.4 4.8 6.9-3.4 1.6-7.3 2.1-11.2 1.5 0.7-3.7 3.1-6.8 6.4-8.4z m-6.6 10.5c0-0.2 0.1-0.3 0.1-0.5 1.1 0.2 2.2 0.3 3.3 0.3 3.1 0 6-0.7 8.8-2 0.3 0.7 0.6 1.3 0.8 1.9-4 1.5-7.6 4.2-10.1 7.9-1.8-2-2.9-4.7-2.9-7.6z m4 8.8c2.4-3.6 5.8-6.2 9.6-7.5 1.2 3.1 1.9 6.3 2.2 9.6-1.3 0.5-2.7 0.8-4.1 0.8-2.9 0-5.6-1.1-7.7-2.9z m13.4 1.4c-0.4-3.2-1.1-6.4-2.2-9.4 2.6-0.7 5.4-0.8 8.1-0.3-0.1 4.1-2.5 7.8-5.9 9.7z' })
        )
    );
};

exports.default = TiSocialDribbble;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-dribbble.js
// module id = 3191
// module chunks = 0